<template>

  <div v-if="isAdmin" class="container">

    <h1 class="text-danger"><i class="fa fa-wrench"></i> Admin Page</h1>
    <hr>


    <div class="admin-menu">
      <router-link to="/admin/users"><i class="fa fa-address-book"></i> users</router-link>
      <router-link to="/admin/set-category-winners/98"><i class="fa fa-trophy"></i> set 2026 winners</router-link>
      <router-link to="/admin/monitor-oscarpool-event-streams"><i class="fa fa-heartbeat"></i> monitor oscarpool event streams</router-link>
      <router-link to="/admin/macrodata-refinement"><i class="fa fa-file-text-o"></i> macrodata refinement</router-link>
      <router-link to="/admin/server-info"><i class="fa fa-server"></i> server info</router-link>
<!--      <router-link to="/admin/test-storefront"><i class="fa fa-shopping-cart"></i> test storefront</router-link>-->
      <router-link to="/admin/sse-test"><i class="fa fa-arrow-circle-down"></i> SSE Test</router-link>
      <router-link to="/admin/friend-graph"><i class="fa fa-users"></i> Friend Graph</router-link>
      <router-link to="/admin/club-graph"><i class="fa fa-users"></i> Club Graph</router-link>
      <router-link to="/admin/streaming-providers"><i class="fa fa-television"></i> Streaming Providers</router-link>
    </div>


    <div class="staging-app-links">
      <hr>
      <h2><i class="fa fa-code"></i> staging</h2>

      <a href="https://mol-staging-app-bedb27305371.herokuapp.com/" target='blank'>
        Staging App <sup><i class="fa fa-external-link"></i></sup>
      </a>
      <a href="https://mol-sandbox-app-27bc8416fe11.herokuapp.com/" target='blank'>
        Sandbox App <sup><i class="fa fa-external-link"></i></sup>
      </a>
      <a href="https://dashboard.heroku.com/apps" target='blank'>
        Heroku <sup><i class="fa fa-external-link"></i></sup>
      </a>
    </div>

    <div class="analytics">
      <hr>

      <h2><i class="fa fa-line-chart"></i> analytics tests</h2>

      <AdminTestAnalytics/>
    </div>

      <div class="tests">
      <hr>

      <h2><i class="fa fa-wrench"></i> tests</h2>


      <button class="btn btn-sm btn-outline-primary" type="button" @click="resetOptInOptOut">
        <i class="fa comment"></i> reset cookie opt-in/opt-out
      </button>


      <button class="btn btn-sm btn-outline-primary" type="button" @click="testToast">
        <i class="fa comment"></i> test toast
      </button>

      <button class="btn btn-sm btn-outline-primary" type="button" @click="testApiCall">
        <i class="fa fa-paper-plane"></i> test api
      </button>

      <button class="btn btn-sm btn-outline-primary" type="button" @click="testHolidays">
        <i class="fa fa-calendar-o"></i> test holidays
      </button>

      <div class="letterboxd-import">
        <p><b><i class="fa fa-movie"></i> test letterboxd import</b></p>
        <input ref="letterboxd-file-input" type="file" accept=".zip">
      </div>

    </div>

  </div>
</template>


<script>
//import axios from "axios";
import {userStore} from "@/userStore";
import axios from "axios";
import {EventBus} from "@/eventBus";
import '@/date-utilities';
import analytics from "@/analytics";
import JSZip from 'jszip';
import Papa from 'papaparse';
import AdminTestAnalytics from "@/components/admin/AdminTestAnalytics.vue";

export default {
  name: "AdminPage",
  components: {AdminTestAnalytics},
  props: [],
  data() {
    return {
    }
  },
  computed: {
    isAdmin() {
      return userStore.isAdmin();
    },
    winIcon() {
      return `${this.$imagePathBase}win_icon-bw.svg`
    }
  },

  mounted() {
    this.$refs["letterboxd-file-input"].addEventListener('change', this.importLetterboxd);
  },
  beforeUnmount() {
    this.$refs["letterboxd-file-input"].removeEventListener('change', this.importLetterboxd);
  },
methods: {

    async importLetterboxd(event) {
      const selectedFile = event.target.files[0];
      // Process the selected file (e.g., upload, display info)
      //console.log(selectedFile.name);

      return selectedFile.arrayBuffer()
          .then(arrayBuffer => {
            //console.log(arrayBuffer);
            return JSZip.loadAsync(arrayBuffer);
          })
          .then(zipObject => {
            //console.log(zipObject);
            return zipObject?.files['watched.csv']?.async("text");
          })

          .then(watchedCsv => {

            if ( watchedCsv ) {
              const watchedJson = Papa.parse(watchedCsv, {
                header: true
              });
              //console.log(watchedJson.data);

              const letterboxdUris = watchedJson.data.map(film => {
                const fullUri = film['Letterboxd URI'];
                if (fullUri) {
                  const indexOfLastSlash = fullUri.lastIndexOf('/');
                  if (indexOfLastSlash > -1) {
                    return fullUri.substring(indexOfLastSlash + 1);
                  }
                }
              }).filter(i => i);

              //console.log(letterboxdUris);

              return axios.post(
                  '/api/film/names',
                  {
                    letterboxd_uris: letterboxdUris
                  })
            }
          })

          .then (response => {

            const filmViewedStates = response.data.map(f => {
              return {
                film_id: f._id,
                viewed: true
              }
            });

            return axios.post(
                '/api/user/set-viewed-states',
                {
                  film_viewed_states: filmViewedStates
                });
          })

          .then(response => {
            console.log(response.data);
          })

          .catch(error => {
            console.error('importLetterboxd() error:', error);
          });



      // return JSZip.loadAsync(zipData)
      //     .then(zip => {
      //       zip.forEach((relativePath, zipEntry) => {
      //         if (zipEntry.dir) {
      //           // Handle directories
      //         } else {
      //           zipEntry.async('string')
      //               .then(content => {
      //                 // `content` is the extracted file content (as a string)
      //                 // You can then process or use the content as needed
      //                 console.log(`Extracted: ${relativePath}`, content);
      //               });
      //         }
      //       });
      //     })


    },

    testToast() {
      //EventBus.emit('toast-notification', "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.");
      EventBus.emit('toast-notification', { message: 'Test toast notification.'});
      EventBus.emit('toast-notification', { message: 'ANOTHER Test toast notification.'});
    },

    resetOptInOptOut() {
      analytics.resetTrackingPreferences();
    },

    async testApiCall() {

      axios.get('api/film/genres')
          //axios.post(`/api/admin/send-test-email/arods.island@gmail.com`)
          .then((response) => {
            // console.log(response);
            analytics.notifyBugsnagOfInfo('admin api response', {'response': response});
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
          });
    },

      testHolidays() {

        const testYear = 2023;

        const holidayFunctionsAndEmojis = {
          isNewYearsDay: '\u{1F389}',      // 🎉
          //isMlkDay: '\u{1F64F}',          // 🙏
          //isGroundhogDay: '\u{1F43E}',    // 🐾
          //isWashingtonsBirthday: '\u{1F1FA}\u{1F1F8}', // 🇺🇸
          //isPresidentsDay: '\u{1F3DB}\u{FE0F}',       // 🏛️
          isValentinesDay: '\u{2764}\u{FE0F}',   // ❤️
          //isLeapDay: '\u{1F438}',         // 🐸
          isStPatricksDay: '\u{1F340}',   // 🍀
          isEaster: '\u{1F430}', // 🐰
          isMothersDay: '\u{1F339}',      // 🌹
          isMemorialDay: '\u{1FA96}', // 🪖
          isFathersDay: '\u{1F454}',      // 👔
          //isJunteenth: '\u{1F389}',       // 🎉
          isIndependenceDay: '\u{1F9E8}', // 🧨
          //isLaborDay: '\u{1F4BC}',        // 💼
          //isColumbusDay: '\u{2693}',      // ⚓
          //isIndigenousPeoplesDay: '\u{1F30E}', // 🌎
          isHalloween: '\u{1F383}',       // 🎃
          //isVeteransDay: '\u{1F1FA}\u{1F1F8}', // 🇺🇸
          isThanksgiving: '\u{1F983}',    // 🦃
          //isBlackFriday: '\u{1F6CD}\u{FE0F}', // 🛍️
          isChristmas: '\u{1F384}',       // 🎄
          //isNewYearsEve: '\u{1F55B}'      // 🕛
        };

        let testDate = new Date(testYear, 0, 1);

        while (testDate.getFullYear() === testYear) {

          for (const [funcName, emojiValue] of Object.entries(holidayFunctionsAndEmojis)) {
            if ( testDate[funcName] && testDate[funcName]() ) {
              console.log(`${testDate.toLocaleDateString()} ${funcName} ${emojiValue}`);
            }
          }
          testDate.setDate(testDate.getDate() + 1);
      }
    }
  }
}
</script>


<style scoped>

.admin-menu {
  a {
    text-decoration: inherit;
    display: block;
  }
}

.staging-app-links {
  margin-top: 50px;

  h2 {
    margin-bottom: 1em;
  }
  a {
    text-decoration: inherit;

    font-weight: 600;
    display: block;
  }
}

.tests {

  h2 {
    margin-bottom: 1em;
  }

  margin-top: 50px;

  button {
    display: block;
    margin-top: 10px;
  }

}

.letterboxd-import {

  color: cornflowerblue;

  padding: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
  border: solid;
  border-color: cornflowerblue;
  border-width: 1px;
  border-radius: 10px;
}

.json-data {
  color: grey;
  font-family: var(--bs-font-monospace);
  margin-top: 2em;

  pre {
    font-size: x-small;
    height: 20em;
    border-width: thin;
    border-style: solid;
    border-color: lightgrey;
    padding: 1em;

  }
}


</style>